export default [
  {
    name: 'rates overview',
    path: '/settings/rates',
    component: () => import('@web/pages/settings/rates/RatesOverview.vue'),
    meta: { title: 'Tarieven' },
    children: [
      {
        name: 'rates',
        path: '',
        components: {
          detailColumn: () =>
            import('@web/components/detail-column/EmptyStateDetailColumn.vue'),
        },
        meta: {
          title: 'Tarieven',
          showContent: true,
        },
      },
      {
        name: 'rates standard-rates edit',
        path: '/settings/rates/edit',
        components: {
          detailColumn: () => import('@web/pages/settings/rates/detail-column/standard/EditStandardRates.vue'),
        },
        meta: { 
          title: 'Standaard tarieven aanpassen',
        },
      },
      {
        name: 'rates different-rates add',
        path: '/settings/rates/different/add',
        components: {
          detailColumn: () => import('@web/pages/settings/rates/detail-column/different/AddDifferentRates.vue'),
        },
        meta: { 
          title: 'Afwijkend tarief toevoegen',
        },
      },
    ],
  },
];
